import css from '../../../utils/css';

const styles = css`
  *[class^='Theme_'] {
    --tsn-black: #080707;
    --tsn-white: #ffffff;
    --tsn-red: #e8262c;
    --tsn-nickel-gray: #7d7d7d;
    --tsn-light-gray: #ebebeb;

    --font-family: Roboto, sans-serif;

    --anchor-color: inherit;
    --outline-color: initial;

    --offer-cta-color: var(--tsn-white);
    --offer-cta-bg-color: var(--tsn-red);
    --offer-cta-bg-color-hover: var(--tsn-red);
  }

  *[class^='Text_'] {
    font-family: var(--secondary-font-family);
  }

  *[class^='Cta_'] > button {
    font-family: var(--primary-font-family-condensed);
  }
`;

export default styles;
